import React, { useEffect, useState } from "react";
import "./typingLoader.css"; // Import CSS file for animation styles

const TypingLoader = () => {
  const [tempLoading, setTempLoading] = useState(0);
  const [messageKey, setMessageKey] = useState(0); // State for changing the key
  const [animation, setAnimation] = useState(true); // State for changing the key

  const messages = [
    "Give me a moment...",
    "Hang tight! Fetching the relevant info...",
    "Almost there! Crafting the response..."
  ];

  useEffect(() => {
    const loadingInterval = setInterval(() => {
      setTempLoading((prevLoading) => {
        if (prevLoading >= 2) {
          setAnimation(false);
          return prevLoading;
        } else {
          setAnimation(true);
          return ++prevLoading;
        }
      });
      setMessageKey((prevKey) => prevKey + 1); // Increment key to trigger re-render
    }, 5 * 1000);

    return () => {
      clearInterval(loadingInterval);
    };
  }, []);

  return (
    <div className="bot-message-loader">
      <p
        key={messageKey}
        className={`loading-message`}
        style={{ animation: animation ? "slideFromTop 1s ease forwards" : "" }}
      >
        {messages[tempLoading]}
      </p>
    </div>
  );
};

export default TypingLoader;
